import { render, staticRenderFns } from "./abc.vue?vue&type=template&id=15dc7074&scoped=true"
import script from "./abc.vue?vue&type=script&lang=js"
export * from "./abc.vue?vue&type=script&lang=js"
import style0 from "./abc.vue?vue&type=style&index=0&id=15dc7074&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dc7074",
  null
  
)

export default component.exports